<template>
  <div class="tree">
    <ul class="tree-list">
      <div
        v-for="folder in foldersData"
        :key="folder.id"
      >
        <FolderNode
          :node="folder"
          :show-questions="showQuestions"
          :is-folder-select="isFolderSelect"
          :select-folder="selectFolder"
          :is-selected-folder="isSelectedFolder"
          :is-question-select="isQuestionSelect"
          :select-question="selectQuestion"
          :selected-question="selectedQuestion"
          :is-selected-question="isSelectedQuestion"
          :show-questions-count="showQuestionsCount"
        />
      </div>
    </ul>
  </div>
</template>

<script>
import FolderNode from "./FolderNode";

export default {
  components: {
    FolderNode
  },
  props: {
    foldersData: {
      type: Array,
      default: () => []
    },
    showQuestions: {
      type: Boolean,
      default: false
    },
    isExpanded: {
      type: Boolean,
      default: false
    },
    isFolderSelect: {
      type: Boolean,
      default: false
    },
    selectedFolder: {
      type: Object,
      default: () => {}
    },
    isQuestionSelect: {
      type: Boolean,
      default: false
    },
    selectedQuestion: {
      type: Object,
      default: () => {}
    },
    showQuestionsCount: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    selectFolder(node) {
      this.$emit('node-click', node);
    },
    isSelectedFolder(folder) {
      if(this.isFolderSelect) {
        return this.selectedFolder.title === folder.title;
      }
    },
    selectQuestion(question) {
      this.$emit('question-select', question);
    },
    isSelectedQuestion(question) {
      if(this.isQuestionSelect) {
        return this.selectedQuestion.text === question.text;
      }
    }
  }
};
</script>

<style>
.tree-list {
  padding-left: 5px;
}

.tree-list ul {
  padding-left: 16px;
  margin: 6px 0;
}
</style>